import { Assets, BitmapText, Container, Sprite } from "pixi.js";
import { IScene, Manager } from "../core/Manager";
import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { FreeGameScene } from "./FreeGameScene";

import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound, Sound } from "@pixi/sound";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusicVolume, globalScreen, isMusicBtnOnGlobal, RespinIndex, setBackgorundMusic, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { CasinoChannelHandler, casinoEventEmitter } from "../core/CasinoChannelHandler";
import { spinData } from "../server/getServerResposesFun";
import { BigWin } from "./BigWin";
// import { REEL_DIVIDER, REEL_FRAME, REEL_NUMBERS, REEL_WIDTH } from "../config/reelConfig";
// import { getSpineSymbol } from "../config/getSymbol";

import { reelSpinEmitter } from "../reels/Reels";

import { isGameAlreadyLoaded, setIsGameAlreadyLoaded } from "../config/GlobalVariableConfig";

declare const window: any;
// const translationManager = window.hacksawCasino.Translation;

// let hand: Spine;

// let tweenLogo: Tween<Spine>;
const tweenGroup: Group = new Group();

export class GameScene extends Container implements IScene {

    // Asset bundles
    assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];

    // Containers
    private background = new Container();
    private reelFrame = new Container();


    private backgroundImageCont = new Container();
    private logo: Spine | null = null;
    private reelBackSpine: Spine | null = null;

    private winMeterstate: number = 0;
    private winMeterSpine: Spine | null = null;

    private backgroundSpine: Spine | null = null;

    private winMult = new Container();
    private currentMultVal: number = 0;
    private winMultFx: Spine | null = null;
    private winMultText: BitmapText | null = null;

    private reels: Reels | null = null;
    // private banner: Banner | null = null;
    private bigWin: BigWin | null = null;

    private backgroundMusic: Sound | null = null;

    private freSpinTrigger: number = 0;
    private freSpinTriggerBaseWin: number = 0;

    private freeGameScene: FreeGameScene | null = null;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;

    // private screenWidth: number = 0;
    // private screenHeight: number = 0;

    private boundUpdateMultiplier: () => void;
    private boundUpdateSurgeMeter: () => void;
    private boundShakeEffect: () => void;

    private pointerDownHandlerBase: () => void;

    constructor() {
        super();

        this.setupEventListeners();

        this.boundUpdateMultiplier = this.updateMultiplier.bind(this);
        this.boundUpdateSurgeMeter = this.updateSurgeMeter.bind(this);
        this.boundShakeEffect = this.shakeEffect.bind(this);

        this.pointerDownHandlerBase = this.onPointerDown.bind(this);

        reelSpinEmitter.on('updateMultiplier', this.boundUpdateMultiplier);
        reelSpinEmitter.on('updateSurgeMeter', this.boundUpdateSurgeMeter);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);



    }

    private setupEventListeners(): void {
        // casinoEventEmitter.on('roundEnded', this.handleRoundEnded.bind(this));
        casinoEventEmitter.on('roundStarted', this.handleRoundStarted.bind(this));
    }

    override  destroy() {
        // Unbind the event listener
        // casinoEventEmitter.off('betAccepted', this.handleBetAccepted.bind(this));

        console.log("inside override  destroy")

        reelSpinEmitter.off('updateMultiplier', this.boundUpdateMultiplier);
        reelSpinEmitter.off('updateSurgeMeter', this.boundUpdateSurgeMeter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);



        casinoEventEmitter.removeAllListeners('roundStarted');
        Assets.unload(['gameIntroSkel', 'gameIntroAtlas', 'baseBackgroundSkel', 'baseBackgroundAtlas']);
        super.destroy();
    }

    // private handleRoundEnded(data: any): void {
    //     console.log('GameScene - roundEnded:', data);
    //     // Add logic to handle round end if needed
    // }


    private shakeEffect() {

        console.log("inside shakeEffect");

        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        const tween = new Tween(offset, tweenGroup)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
                tweenGroup.remove(tween);
            })
            .start();
    }

    private async handleRoundStarted() {
        // console.log('GameScene - betAccepted:', spinResponseData);
        // setSpinResponseDataGlobal(spinResponseData);
        this.spinReel();

        // // Delay result display report
        // setTimeout(() => {

        // }, 500);

        if (!spinData.dataFeatched) {
            await this.waitForData();
        }

        Manager.casinoChannelHandler.reportResultDisplay();


    }

    private waitForData(): Promise<void> {
        return new Promise<void>((resolve) => {
            const checkInterval = setInterval(() => {
                if (spinData.dataFeatched) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100); // Check every 100ms

        });
    }

    private onPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage pointerdown");
        this.freeGameSceneChnage();

        Manager.banner.bgContainer.off('pointerdown', this.pointerDownHandlerBase);
    }

    public async constructorWithAssets(): Promise<void> {



        this.setupBackground();

        this.setupLogo();

        this.setupWinMult();


        // this.setupBGSound();

        this.reels = new Reels();
        this.background.addChild(this.reels);
        this.reels.position.set(614, 572);
        this.reels.alpha = 0;

        if (isGameAlreadyLoaded) { // meaning coming from free game;
            this.setupReelFrame(false);
            // when coming from free-> base then music will be chnaged in the banner disappear

            // this.setupBGSound();
        }
        else {
            this.setupReelFrame(true);
        }



        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);
        this.addChild(this.bigWin);

        // setTimeout(async () => {
        //     await this.bigWin.bigWinFunction(10000);
        // }, 2000);



        // this.banner = new Banner(Manager.screenwidth, Manager.screenHeight);
        // this.addChild(Manager.banner);

        // Manager.banner.bgContainer.once('pointerdown', () => {
        //     clearTimeout(this.autoTriggerTimeout);
        //     console.log("calling freeGameSceneChnage pointerdown")
        //     this.freeGameSceneChnage();
        // });



        this.updateMultiplier(0);
        this.updateSurgeMeter(0);

        // const idRandom = 7;
        // const symbol1 = getSpineSymbol(idRandom);
        // symbol1.state.setAnimation(0, "flip", true);
        // symbol1.position.set(-200, 200);
        // this.reels.addChild(symbol1);

        // const symbol2 = getSpineSymbol(idRandom);
        // symbol2.state.setAnimation(0, "static", true);
        // symbol2.position.set(300, 200);
        // this.reels.addChild(symbol2);



        // setTimeout(() => {
        //     symbol.state.clearTrack(0);
        //     symbol.skeleton.setToSetupPose();
        // }, 2000);

        // await Manager.banner.appearFreeGameIntroBanner(12);
        // await Manager.banner.appearFreeGameOutroBanner(22513.65, 10);

        // await this.bigWin.bigWinFunction(1000);

        // await this.banner.appearFreeGameIntroBanner(10);

        //***********  translation ******************/
        //"free_spins_splash_body": "The best things in life are free!"
        // const string1 = translationManager.game('free_spins_splash_body');
        // console.log(string1);

        // // "num_free_spins_played": ":totalFreespins free spins played :x",
        // const string2 = translationManager.game('num_free_spins_played', null, { 'totalFreespins': 10, 'x': 20 });
        // console.log(string2);


        // const textval = new BitmapText({
        //     text: "123456789.0,",
        //     style: {
        //         fontFamily: 'Street_knockout_win2',
        //         fontSize: 60
        //     }
        // });
        // textval.position.set(-200, -200);
        // this.reels.addChild(textval);


        this.resize(Manager.screenwidth, Manager.screenHeight);

    }


    private updateMultiplier(multVal: number): void {

        console.log("reelSpinEmitter:updateReelMult", multVal)

        if (multVal == 0) {
            this.winMultText.text = `X1`
        }
        else if (multVal > 0) {

            this.winMultText.text = `X${multVal}`

            if (multVal > this.currentMultVal) {

                let scaleVal = 1.10;
                if (multVal - this.currentMultVal > 1) {
                    //meaning swril multiplier
                    scaleVal = 1.45;
                }

                const tweenBreath = new Tween(this.winMultText.scale, tweenGroup)
                    .to({ x: scaleVal, y: scaleVal }, 150) // Scale up
                    .yoyo(true) // Automatically reverses the tween
                    // .repeat(1) // Infinite loop
                    .onComplete(() => {
                        tweenGroup.remove(tweenBreath);
                        this.winMultText.scale = 1;
                    })
                    .start();

                this.winMultFx.state.setAnimation(0, "animation", false);

                sound.play("Meter_Section_Fills", { volume: 0.2 });
            }
        }

        this.currentMultVal = multVal;

        // this.shakeEffect();
    }

    private updateSurgeMeter(meterVal: number): void {
        // cap the meterVal
        meterVal = (meterVal > 5) ? 5 : meterVal

        console.log("gamescene:reelSpinEmitter:updateSurgeMeter", meterVal, this.winMeterstate);

        if (meterVal == 0 && this.winMeterstate > 0) {

            let currentMeterState = this.winMeterstate;
            this.winMeterstate = 0;
            this.winMeterSpine.state.setAnimation(0, `reset_${currentMeterState}`, false).listener = {
                complete: () => {
                    this.winMeterSpine.state.clearListeners();
                    this.winMeterstate = meterVal;
                }
            }
        }
        else if (meterVal > 0 && meterVal == this.winMeterstate + 1) { // meterVal > this.winMeterstate was not correct 
            this.winMeterstate = meterVal;

            if (meterVal == 5) {
                sound.play("Meter_Gets_Full", { volume: 0.5 });
            }
            else {
                sound.play("Multiplier_Update", { volume: 0.2 });
            }

            this.winMeterSpine.state.setAnimation(0, `fill_${meterVal}`, false).listener = {
                complete: () => {
                    this.winMeterSpine.state.setAnimation(0, `idle_${meterVal}`, true);
                    this.winMeterSpine.state.clearListeners();
                }
            }
        }
    }


    private setupWinMult() {


        // private winMult = new Container();
        // private winMultFx: Spine | null = null;
        // private winMultText: BitmapText | null = null;

        this.winMult.alpha = 0;
        this.background.addChild(this.winMult);

        const multBase = Sprite.from('multiplier_base');
        multBase.anchor = 0.5;
        this.winMult.addChild(multBase);


        this.winMultFx = Spine.from({
            skeleton: "multFxSkel",
            atlas: "multFxAtlas",
        });
        this.winMultFx.scale = 1.5;
        this.winMult.addChild(this.winMultFx);
        // this.winMultFx.state.setAnimation(0, "animation", true);

        this.winMultText = new BitmapText({
            text: "X1",
            style: {
                fontFamily: 'sugar_multiplier',
                fontSize: 120
            }
        });
        this.winMultText.anchor = 0.5;
        this.winMultText.position.set(0, -15);
        this.winMult.addChild(this.winMultText);

    }

    private setupBGSound() {
        this.backgroundMusic = sound.find('base_music_loop'); // initialize with ambient sound
        setBackgorundMusic(this.backgroundMusic);

        if (this.backgroundMusic) {
            this.backgroundMusic.loop = true;
            this.backgroundMusic.volume = 0;//currentBackgorundMusicVolume;
            // console.log("this.backgroundMusic.volume", this.backgroundMusic.volume);
            this.backgroundMusic.singleInstance = true;
            // this.backgroundMusic.speed = 0.5;
            this.backgroundMusic.play();

            this.backgroundMusic.muted = !isMusicBtnOnGlobal;

            const tween = new Tween(this.backgroundMusic, tweenGroup)
                .to({ volume: currentBackgorundMusicVolume }, 2000)
                .onComplete(() => {
                    tweenGroup.remove(tween);
                })
                .start();

        }
    }

    private callFreeGameSceneChnageAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            console.log("calling freeGameSceneChnage auto")
            clearTimeout(this.autoTriggerTimeout);
            this.freeGameSceneChnage();
        }, 10000); // 10 seconds
    }

    private async spinReel(): Promise<void> {

        this.updateMultiplier(0);
        this.updateSurgeMeter(0);

        if (this.reels) {

            const [freeGameTrigger, winAmount] = await this.reels.startPlay("BASE");
            console.log("in GameScene freeGameTrigger winAmount RespinIndex.value", freeGameTrigger, winAmount, RespinIndex.value);

            if (freeGameTrigger > 0 && Manager.banner) {

                this.freSpinTrigger = freeGameTrigger;
                this.freSpinTriggerBaseWin = winAmount;

                // await this.freeGameSceneChnage(freeGameTrigger, winAmount);
                // this.backgroundMusic?.stop();
                await this.reels?.processWinFeatureSymbol(RespinIndex.value - 1);

                Manager.casinoChannelHandler.reportFeatureEnter();

                await Manager.banner.appearFreeGameIntroBanner(this.freSpinTrigger);
                //attach a listner now
                Manager.banner.bgContainer.on('pointerdown', this.pointerDownHandlerBase);

                console.log("appearFreeGameIntroBanner");

                if (willBannerAutoProceedGlobal) {
                    this.callFreeGameSceneChnageAuto();
                }

                this.freeGameScene = new FreeGameScene(this.freSpinTrigger, this.freSpinTriggerBaseWin);
                await Manager.changeScene(this.freeGameScene, false);

                // this.freeGameSceneChnage(this.freSpinTrigger, this.freSpinTriggerBaseWin)
            }
            else if (winAmount === -1) {
                console.log("in Gamescene- Bet declined");
            }
            else {
                await this.bigWin?.bigWinFunction(winAmount);
                Manager.casinoChannelHandler.reportGameRoundCompleted();
                // reportGameRoundCompleted();
            }

            if (freeGameTrigger === -2) { // max win reached 
                Manager.casinoChannelHandler.reportMaxWin();
            }

            this.reels?.setReelRunning(false);
        }
    }

    private async freeGameSceneChnage() {


        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner(true);

        this.freeGameScene?.freeSpinPlay();


        // Manager.casinoChannelHandler.reportFeatureEnter();

        // const game = new FreeGameScene(freeGameTrigger, baseGameWin);
        // await Manager.changeScene(game, false);

    }


    private setupBackground(): void {

        this.backgroundImageCont.addChild(Sprite.from('background'));
        this.addChild(this.backgroundImageCont);


        // this.background.addChild(Sprite.from('baseReels'));

        this.backgroundSpine = Spine.from({
            skeleton: "baseBackgroundSkel",
            atlas: "baseBackgroundAtlas",
            // skeleton: "freeBackgroundSkel",
            // atlas: "freeBackgroundAtlas",
        });

        this.backgroundSpine.position.set(globalScreen / 2, globalScreen / 2);

        // spineSymbol.scale=0.1;

        this.backgroundSpine.state.setAnimation(0, "animation", true);
        // spineSymbol.state.setAnimation(0, "win", true);
        this.background.addChild(this.backgroundSpine);

        this.addChild(this.background);


    }


    private setupLogo(): void {

        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });

        this.logo.alpha = 0;

        this.background.addChild(this.logo);
        this.logo.state.setAnimation(0, "animation", true);

    }


    private setupReelFrame(doAnimate: boolean): void {


        const reelBackSlidesSpine = Spine.from({
            skeleton: "reelBackSliderSkel",
            atlas: "reelBackSliderAtlas"
        })
        reelBackSlidesSpine.position.set(globalScreen / 2, 324);
        reelBackSlidesSpine.alpha = 0;
        this.background.addChild(reelBackSlidesSpine);

        this.reelBackSpine = Spine.from({
            skeleton: "reelBackSkel",
            atlas: "reelBackAtlas"
        })

        this.reelFrame.addChild(this.reelBackSpine);

        this.background.addChild(this.reelFrame);
        this.reelFrame.position.set(globalScreen / 2, globalScreen / 2);


        this.winMeterSpine = Spine.from({
            skeleton: "meterSkel",
            atlas: "meterAtlas"
        })
        this.background.addChild(this.winMeterSpine);
        this.winMeterSpine.alpha = 0;

        if (doAnimate) {

            //put reel logo mult on top
            this.background.addChild(this.reels);
            this.background.addChild(this.logo);
            this.background.addChild(this.winMult);

            sound.play('Screen_Falling');


            this.reelBackSpine.state.setAnimation(0, "appear", false).listener = {
                complete: () => {


                    this.reelBackSpine.state.setAnimation(0, "animation", true);



                    const reelWaterfallSpine = Spine.from({
                        skeleton: "reelWaterfallSkel",
                        atlas: "reelWaterfallAtlas"
                    })
                    reelWaterfallSpine.position.set(globalScreen / 2, globalScreen / 2);
                    this.background.addChild(reelWaterfallSpine);


                    reelBackSlidesSpine.alpha = 1;
                    reelBackSlidesSpine.state.setAnimation(0, "appear", false).listener = {
                        complete: () => {
                            reelBackSlidesSpine.state.setAnimation(0, "animation", true);
                            reelBackSlidesSpine.state.clearListeners();
                        }
                    };

                    // const tween = new Tween(this.reels, tweenGroup)
                    //     .to({ alpha: 1 }, 500)
                    //     .delay(500)
                    //     .onComplete(() => {
                    //         tweenGroup.remove(tween);
                    //     })
                    //     .start();


                    let currentVal = 0;
                    const targetVal = 1;
                    const tween = new Tween({ x: currentVal }, tweenGroup)
                        .to({ x: targetVal }, 500)
                        .delay(1250)
                        .onUpdate((object) => {
                            currentVal = object.x;
                            this.reels.alpha = currentVal;
                            this.logo.alpha = currentVal;
                            this.winMult.alpha = currentVal;
                        })
                        .onComplete(() => {
                            tweenGroup.remove(tween);
                            this.reels.alpha = 1;
                            this.logo.alpha = 1;
                            this.winMult.alpha = 1;
                            // this.logo.scale = 1;
                            // this.winMult.scale = 1;
                        })
                        .start();

                    sound.play('Water_Fall');
                    reelWaterfallSpine.state.setAnimation(0, "animation", false).listener = {
                        complete: () => {
                            CasinoChannelHandler.reportGameStarted();
                            setIsGameAlreadyLoaded(true);

                            reelWaterfallSpine.state.clearListeners();

                            this.setupBGSound();


                            sound.play('Meter_Appear');
                            this.winMeterSpine.alpha = 1;
                            this.winMeterSpine.state.setAnimation(0, "appear", false);
                            // this.winMeterSpine.state.setAnimation(0, "idle_3", false);

                        }
                    };

                    this.reelBackSpine.state.clearListeners();
                }
            };

        }
        else {

            //put reel on top
            this.background.addChild(this.reels);
            this.background.addChild(this.logo);
            this.background.addChild(this.winMult);

            this.reels.alpha = 1;
            this.logo.alpha = 1;
            this.winMult.alpha = 1;
            this.winMeterSpine.alpha = 1;

            this.reelBackSpine.state.setAnimation(0, "animation", true);

            reelBackSlidesSpine.alpha = 1;
            reelBackSlidesSpine.state.setAnimation(0, "animation", true);

            this.winMeterSpine.state.setAnimation(0, "appear", false);

            // CasinoChannelHandler.reportGameStarted();

        }
    }






    public update(): void {
        tweenGroup.update();
        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        // this.screenWidth = screenWidth;
        // this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / globalScreen, screenHeight / globalScreen);


        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale.set(scale, scale);

            const xPos = (globalScreen * scale - screenWidth) / 2;
            const yPos = (globalScreen * scale - screenHeight) / 2;

            this.background.x = -xPos;
            this.background.y = -yPos;

            if(this.logo){
                this.logo.scale = 1;
                this.logo.position.set(284, 724);

            }
            this.winMult.scale = 1;
            this.winMult.position.set(284, globalScreen / 2);

            if (this.winMeterSpine) {
                this.winMeterSpine.rotation = 0;
                this.winMeterSpine.position.set(1544, 959);
            }


            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
            const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

        }
        else {
            scale = 1.22 * Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale = scale;

            const xPos = (globalScreen * scale - screenWidth) / 2;
            const yPos = (globalScreen * scale - screenHeight) / 2;

            this.background.x = -xPos;
            this.background.y = -yPos;

            if(this.logo){
                this.logo.scale = .75;
                this.logo.position.set(globalScreen / 2, 384);
            }

            this.winMult.scale = .8;
            this.winMult.position.set(1314, 444);


            if (this.winMeterSpine) {
                this.winMeterSpine.rotation = Math.PI / 2;
                this.winMeterSpine.position.set(1024, 1444);
            }

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
            const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

        }


        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, screenHeight / 2);
        this.bigWin?.resize(screenWidth, screenHeight);

        // this.banner?.resize(screenWidth, screenHeight);

    }


}
